import { colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import styled from 'styled-components'

export const EditorFooterContainer = styled.div`
  border-radius: ${spacing.px24};
  background: ${colors.grey050};
  padding: ${spacing.px12} ${spacing.px16};
  margin-top: ${spacing.px8};
  position: sticky;
  bottom: ${spacing.px16};
`

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.px8};
`

export const ToolbarContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 1;
  gap: ${spacing.px12};
`
export const CountContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 11.5rem;
`

export const WordCount = styled(Typography).attrs({
  variant: 'body2',
  variantType: 'normal',
})`
  color: ${colors.grey900};
  font-weight: 600;
`

export const Disclaimer = styled(Typography).attrs({
  variant: 'caption',
  variantType: 'normal',
  tag: 'p',
})`
  color: ${colors.grey500};
  line-height: ${font.lineHeight.sm};

  &.footerbar {
    font-size: ${font.size.px14};
  }

  /* for feature undo-redo enabled */
  &.undoRedo {
    padding: ${spacing.px12} ${spacing.px24} ${spacing.px12} ${spacing.px40};
    margin: ${spacing.px12} calc(372px + 3rem) 0 208px;
    font-size: ${font.size.px12};
  }
`

export const DisclaimerLink = styled.a`
  text-decoration-line: underline;
  color: ${colors.grey500};
`

export const ButtonTooltip = styled.div`
  line-height: ${font.lineHeight.sm};
  font-size: ${font.size.px12};
  font-weight: ${font.weight.normal};
`
